<template>
  <div>
    <HeadBack title="商品详情" />
    <div id="productPage">
      <div class="storeInfo">
        <div class="topStore">
          <img :src="storeInfo.logoUrl" alt="" class="imgStore">
          <div class="rightStore">
            <div class="flexSty">
              <p class="name">{{ storeInfo.storeName }}</p>
              <p class="constrc">订货中心</p>
            </div>
            <div class="flexBtSty">
              <div class="storeDesc">
                {{ storeInfo.detail }}
              </div>
            </div>
          </div>
        </div>
        <div class="rightCon">
          <p class="acbtn" @click="showCotract(storeInfo.note)"> <img src="@/assets/images/mall/kfIcon.png" alt="" class="imgIcon">联系商家</p>
          <p class="acbtn" style="margin-top: 10px;" @click="goStore"><img src="@/assets/images/mall/storeIcon.png" alt="" class="imgIcon"> 进入店铺</p>
        </div>
      </div>
      <div class="threeContent">
        <div class="firstRow">
          <div class="leftWrap">
            <wheelSeed :img-url-list="goodDetail.newImgs" />
          </div>
          <div class="rightWrap">
            <div class="topRow">
              <div class="rightRow">
                <p class="titles">{{ goodDetail.commodityName }}</p>
              </div>
              <div class="addressWrap">
                <div class="oneRow">
                  <div class="oneCol">库存：{{ goodDetail.reserve ? goodDetail.reserve : 0 }} {{ goodDetail.unitQuantifier }}</div>
                  <!-- <div class="oneCol">已售：{{ goodDetail.salesNumber ? goodDetail.salesNumber : 0 }} {{ goodDetail.unitQuantifier }}</div> -->
                  <div class="oneCol">产地：{{ goodDetail.placeOrigin }}</div>
                </div>
                <!-- <div class="constrct">
                  联系方式：{{ goodDetail.contactInfo }}
                </div> -->
                <div v-if="JSON.stringify(addressObj)!='{}'" class="addressInfo">
                  <div class="btwInfo">
                    <div>
                      送至：
                      <span>{{ addressObj.addressName }} </span>
                    </div>
                    <i class="el-icon-arrow-right" @click="addList"></i>
                  </div>
                </div>
                <div v-else class="addressInfo" @click="goAddress">
                  <span>暂无地址 <span class="addAddress" @click="goAddress">去添加</span></span>
                </div>
                <div class="constrct">
                  快递：免运费
                </div>
              </div>
              <div class="priceWrap">
                {{ goodDetail.retailPrice==-1?'采购价': '零售价' }}
                <span class="price">¥{{ goodDetail.retailPrice==-1?goodDetail.purchasePrice: goodDetail.retailPrice }}</span>
                <span v-if="rewardRate" class="prices">{{ rewardRate }}</span>
                <!-- 原价<span class="marketP">¥{{ goodDetail.marketPrice }}</span> -->

              </div>
              <div class="plusBtn">
                <el-input-number v-model="buyNum" :min="1" label="" :precision="0"></el-input-number>
              </div>
            </div>
            <div class="bottomRow">
              <div class="btnAction" :class="isSale?'disSty':''" @click="handleBuy">{{ isSale?'已售罄':'立即订货' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detailDesc">
        <div class="titls">商品详情</div>
        <div class="des">
          <div v-html="goodDetail.introduction"></div>
        </div>
      </div>
    </div>
    <addressPop ref="addressDia" :is-detail="true" @complate="complateAddress" />
    <addListDialog ref="addListDia" :choose-add-id="addressObj.addressId" @changAddId="changeAddId" />
    <contractInfo ref="contrantRef" />
  </div>
</template>
<script>
/*global http protocol BaseApi*/
import HeadBack from '@/components/base/header/HeadBack.vue'
import wheelSeed from '@/components/base/wheelSeed/wheelSeed.vue'
import addressPop from '@/components/address/addressPop.vue'
import addListDialog from '@/components/address/addListDialog.vue'
import contractInfo from '@/components/contractInfo/contractInfo.vue'
export default {
  components: {
    wheelSeed,
    addressPop,
    addListDialog,
    HeadBack,
    contractInfo
  },
  data() {
    return {
      showDialog: false,
      storeInfo: {
        logoUrl: '',
        storeName: null,
        note: null,
        detail: null,
        storeId: null
      },
      pathFrom: sessionStorage.getItem('buyFrom') === '1',
      goodDetail: {

      },
      skuInfo: {
        skuName: '',
        skuPrice: '',
        moneyPrice: '',
        giveQuantity: ''
      },
      buyNum: 1,
      addressObj: {}
    }
  },
  computed: {
    rewardRate() {
      const reate = this.goodDetail.retailPrice === -1 ? this.goodDetail.purchaseRate : this.goodDetail.retailRate
      return Number(reate) > 0 ? '赠送' + reate * 100 + '%店铺数字权益' : this.goodDetail.specialHint
    },
    isSale() {
      const isFalse = this.goodDetail.reserve ? this.goodDetail.reserve : 0
      return isFalse <= 0
    }
  },
  mounted() {
    this.getDetail()
    this.storeInfo = JSON.parse(sessionStorage.getItem('storeInfo'))
    const defalutAdd = sessionStorage.getItem('defaultAddress')
    if (defalutAdd) {
      // sessionStorage.setItem('chooseAddress', defalutAdd)
      this.addressObj = JSON.parse(defalutAdd)
    } else {
      this.queryFirmAddress()
    }
  },

  methods: {
    showCotract(phones) {
      this.$refs.contrantRef.openDialog(phones)
    },
    goStore() {
      sessionStorage.setItem('storeInfo', JSON.stringify(this.storeInfo))
      this.$router.push('/storeDetail')
    },
    complateAddress() {
      this.queryFirmAddress()
    },
    getMyAsset() {
      http.postFrontMall(protocol.param_findMyAssetMarket).then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.goodDetail.addressId = this.addressObj.addressId
            this.goodDetail.buyNum = this.buyNum
            sessionStorage.setItem('sureObj', JSON.stringify(this.goodDetail))
            this.$router.push('/productSure')
          }
        } else {
          this.$message(message)
        }
      })
    },
    getDetail() {
      protocol.param_findCommodity.param.firmTopId = null
      protocol.param_findCommodity.param.page = 0
      protocol.param_findCommodity.param.size = 1
      protocol.param_findCommodity.param.classId = null
      protocol.param_findCommodity.param.mallFlag = 'S'
      protocol.param_findCommodity.param.commodityId = this.$route.params.commodityId
      protocol.param_findCommodity.param.storeId = null
      protocol.param_findCommodity.param.commodityName = null
      http.postFrontMall(protocol.param_findCommodity).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value.content.length > 0) {
            const newArray = value.content[0].imgs.filter((e) => {
              return e.isMain !== '1'
            })
            const item = value.content[0]
            value.content[0].price = item.price
            value.content[0].marketPrice = item.skus[0].skuPrice
            value.content[0].newImgs = newArray
            this.goodDetail = value.content[0]
            this.skuInfo = this.goodDetail.skus[0]
          }
        } else {
          this.$message(message)
        }
      })
    },
    handleBuy() {
      if (this.isSale) {
        return
      }
      if (JSON.stringify(this.addressObj) === '{}') {
        this.$message('请添加收货地址')
        return
      }
      if (!this.buyNum) {
        this.$message('请输入购买数量')
        return
      }
      this.getMyAsset()
    },
    changeAddId(address) {
      this.addressObj = address
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      BaseApi.getUserAddress({}).then((response) => {
        // eslint-disable-next-line no-unused-vars
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            for (const item of value) {
              if (item.defaultFlag) {
                this.addressObj = item
                sessionStorage.setItem('defaultAddress', JSON.stringify(item))
                // sessionStorage.setItem('chooseAddress', JSON.stringify(item))
              }
            }
          }
        } else {
          this.$message(message)
        }
      })
    },
    addList() {
      const params = {
        id: this.addressObj.addressId
      }
      this.$refs.addListDia.openDialog(params)
    },
    goAddress() {
      const params = {
        isAdd: 'add'
      }
      this.$refs.addressDia.openDialog(params)
    }
  }
}
</script>
<style lang="scss" scoped>
#productPage{
  .storeInfo{
        width:1200px;
        margin: 30px auto 0;
        background: #424556;
        border-radius: 20px 20px 20px 20px;
        padding:20px 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .topStore{
          display: flex;
          align-items: center;
          width:calc(100% - 288px);
          .imgStore{
            width: 60px;
            height: 60px;
            border-radius: 43px 43px 43px 43px;
            margin-right: 13px;
          }
          .flexSty{
            display: flex;
            align-items: center;
          }
          .flexBtSty{
            margin-top:10px;
          }
          .name{
            font-size: 20px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #C99F62;
            line-height: 23px;
          }
          .constrc{
            margin-left:6px;
            width: 60px;
            height: 20px;
            background: #76634D;
            border-radius: 4px 4px 4px 4px;
            font-size: 12px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #DECAA2;
            line-height: 20px;
            text-align: center;
            // cursor: pointer;
          }
        }
        .storeDesc{
          width:810px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 14px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 这里是超出几行省略 */
          overflow: hidden;
        }
        .rightCon{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .acbtn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 106px;
            height: 34px;
            border-radius: 43px 43px 43px 43px;
            border: 1px solid #606374;
            font-size: 14px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #FFFFFF;
            box-sizing: border-box;
            cursor: pointer;
            .imgIcon{
              width:20px;
              margin-right: 4px;
            }
          }
        }
      }
 .threeContent{
    width:1200px;
    margin:20px auto 0;
    .firstRow{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #424556;
        border-radius: 20px 20px 20px 20px;
        padding:47px 40px 32px;
    }
    .leftWrap{
      width:430px;
    }
    .imgWraps{
      width:430px;
      height: 430px;
    }
    .rightWrap{
      width:710px;
      height: 528px;
      margin-left:60px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .topRow{
        .rightRow{
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .titles{
          font-size: 24px;
          font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
          font-weight: bold;
          color: #9EA5AC;
          line-height: 38px;
        }
        .name{
          font-size: 18px;
          font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
          font-weight: 500;
          color: #BFC5CB;
          line-height: 21px;
        }
        .addressWrap{
            margin-top:40px;
            .oneRow{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .oneCol{
                    font-size: 18px;
                    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                    font-weight: 500;
                    color: #9EA5AC;
                }
            }
            .constrct{
                margin-top:30px;
                font-size: 18px;
                font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                font-weight: 500;
                color: #9EA5AC;
            }
            .addressInfo{
               margin-top:30px;
               font-size: 18px;
                font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                font-weight: 500;
                color: #9EA5AC;
                /deep/.el-icon-arrow-right{
                  cursor: pointer;
                }
                .btwInfo{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  div,span{
                    color:#9EA5AC;
                  }
                }
                .addAddress{
                    color:#FFFFFF;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
        .priceWrap{
            margin-top:60px;
            font-size: 18px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #BFC5CB;
          .price{
            position: relative;
            top:2px;
            font-size: 42px;
            font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
            font-weight: normal;
            color: #E4CA91;
            margin-left: 0px;
            margin-right: 14px;
          }
          .prices{
            font-size: 18px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #BFC5CB;
            line-height: 21px;
          }
          .marketP{
            margin-left: 4px;
            text-decoration: line-through;
            color:#BFC5CB;
          }
        }
      }
      .plusBtn{
        margin-top:30px;
          /deep/.el-input-number{
            height: 40px;
            line-height: 40px;
            width: 140px;
            .el-input-number__decrease,.el-input-number__increase{
              height: 40px;
              background: #292C3A;
              border-radius: 4px 0px 0px 4px;
              border-color:#595B6C;
              color: #FFFFFF;
            }
            [class*=" el-icon-"], [class^=el-icon-]{
              color: #FFFFFF;
            }
            .el-input-number__increase{
              border-radius: 0px 4px 4px 0px;
            }
            .el-input-number__decrease.is-disabled .el-icon-minus, .el-input-number__increase.is-disabled .el-icon-minus{
             color:#9d9ea2;
           }
            .el-input__inner{
              padding-left: 30px;
              padding-right: 30px;
              height: 41px;
              line-height: 41px;
              border:none;
              background: #292C3A;
              font-size: 20px;
              font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
              font-weight: normal;
              color: #FFFFFF;
            }
          }
        }
      .bottomRow{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .btnAction{
          width: 119px;
            height: 40px;
            background: #E4CA91;
            border-radius: 4px 4px 4px 4px;
            font-size: 20px;
            font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
            font-weight: bold;
            color: #5E4207;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
        }
        .disSty{
          color:#E8E8E8;
          background: #B6B6B6;
        }
      }
    }
 }
 .detailDesc{
  width:1200px;
      background: #424556;
       border-radius: 20px 20px 20px 20px;
      margin: 20px auto 0;
      .titls{
        font-size: 20px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 67px;
        padding-left:40px;
        border-bottom: 1px solid #3B3E4E;
      }
      .des{
        width:750px;
        margin:0px auto;
        padding:30px 0;
      }
 }
}
</style>
